export default __webpack_public_path__ + "media/images/home/slide_new_plan_2025_sm-55b23c06dbc7419a24a0dc36003e87f8.jpg";